import socketIO from 'socket.io-client';
import { getCookie } from 'utils/cookies';

const socket = {
  _instance: null,

  get instance() {
    return this._instance;
  },

  async connect(userId) {
    if (!this._instance) {
      const accessToken = getCookie('access_token');

      if (!accessToken) {
        throw new Error('Access token is required to connect to websocket')
      }

      this._instance = socketIO.connect(import.meta.env.VITE_SOCKET_URL, {
        query: {
          user_id: userId,
          token: accessToken,
        },
        auth: {
          user_id: userId,
          token: accessToken,
        },
        transports: ['websocket', 'polling'],
        timeout: 20000,
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionAttempts: 5,
      });

      // Обработка ошибок подключения - не выбрасываем исключение, чтобы не прерывать авторизацию
      this._instance.on('connect_error', (error) => {
        console.warn('Socket.IO connection error:', error.message);
        // Не прерываем процесс авторизации из-за ошибки Socket.IO
      });

      this._instance.on('connect', () => {
        if (this._instance) {
          this._instance.emit('notify.subscribe');
        }
      });

      // Ожидаем подключения с таймаутом
      return new Promise((resolve, reject) => {
        const timeout = setTimeout(() => {
          // Не считаем таймаут критической ошибкой - Socket.IO может подключиться позже
          console.warn('Socket.IO connection timeout, but continuing...');
          resolve();
        }, 5000);

        this._instance.once('connect', () => {
          clearTimeout(timeout);
          resolve();
        });

        this._instance.once('connect_error', (error) => {
          clearTimeout(timeout);
          // Не reject, чтобы не прерывать авторизацию
          console.warn('Socket.IO connection failed:', error.message);
          resolve(); // Разрешаем промис, чтобы не блокировать авторизацию
        });
      });
    }
  },

  disconnect() {
    if (this._instance) {
      this._instance.disconnect();
      this._instance = null;
    }
  },
};

export { socket };
